// Core
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

// Styles
import "./styles.scss";

// Custom layout
import MainLayout from "Layouts/Main";

// Assets
import Colors from "../../../../Assets/SassConstants/colors.scss";
import Back from "../../../../Assets/Svg/Admin/AssessmentBacklog/backChevron.svg";
import Profile from "../../../../Assets/Svg/Admin/StaffManagement/profile.svg";

// Custom component
import CircleImageView from "Components/CircleImageView";

const ViewStaff = () => {
  // Initialize useNavigate
  const navigate = useNavigate();
  const location = useLocation();
  const { selectedStaffDetails } = location.state || {};

  return (
    <MainLayout style={{ backgroundColor: Colors.grey_12 }}>
      <div className="staff-management-page">
        <div
          onClick={() => {
            navigate(-1);
          }}
          className="staff-management-back-option"
        >
          <img src={Back} alt="Back" />
          <span className="staff-management-back-text">
            Back to Staff Management
          </span>
        </div>

        <div className="add-staff-container">
          <div className="add-staff-title">Staff Details</div>
          <hr className="add-staff-divider" />
          <div className="staff-details-card">
            <div className="staff-details-card-header">
              <div className="staff-details-profile-container">
                {!!selectedStaffDetails?.profile_image ? (
                  <CircleImageView
                    imageUrl={selectedStaffDetails?.profile_image}
                    size={60}
                  />
                ) : (
                  <img src={Profile} />
                )}
              </div>
              <div className="staff-details-staff-name-container">
                {selectedStaffDetails?.user_name}
              </div>
            </div>

            <div className="staff-details-card-body">
              <div className="staff-details-card-body-row">
                <div className="staff-details-card-body-row-key">
                  Employee ID
                </div>
                <div className="staff-details-card-body-row-value">
                  : {selectedStaffDetails?.user_code}
                </div>
              </div>
              <div className="staff-details-card-body-row">
                <div className="staff-details-card-body-row-key">
                  Mobile Number
                </div>
                <div className="staff-details-card-body-row-value">
                  : {selectedStaffDetails?.country_code}&nbsp;{selectedStaffDetails?.mobile}
                </div>
              </div>
              <div className="staff-details-card-body-row">
                <div className="staff-details-card-body-row-key">Email ID</div>
                <div className="staff-details-card-body-row-value">
                  : {selectedStaffDetails?.email}
                </div>
              </div>
              <div className="staff-details-card-body-row">
                <div className="staff-details-card-body-row-key">Role</div>
                <div className="staff-details-card-body-row-value">
                  : {selectedStaffDetails?.role === 2 ? "Assessor" : null}
                </div>
              </div>
              <div className="staff-details-card-body-row">
                <div className="staff-details-card-body-row-key">
                  LinkedIn Profile Link
                </div>
                <div className="staff-details-card-body-row-value">
                  : {selectedStaffDetails?.linkedInUrl}
                </div>
              </div>
              <div className="staff-details-card-body-row">
                <div className="staff-details-card-body-row-key">Bio</div>
                <div className="staff-details-card-body-row-value">
                  : {selectedStaffDetails?.bio}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default ViewStaff;
